import * as React from "react";
import type { SVGProps } from "react";

const FacilityTaxiCarPool = React.memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    focusable="false"
    {...props}
  >
    <path
      d="M12.5 5.00033L12.2033 3.57995C12.1227 3.19372 11.7822 2.917 11.3876 2.91699H8.64762C8.26038 2.917 7.92416 3.18375 7.83612 3.56085L7.5 5.00033"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.0833 15.0967V16.667C17.0833 17.1272 16.7102 17.5003 16.25 17.5003H14.5833C14.1231 17.5003 13.75 17.1272 13.75 16.667V15.417"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.2513 15.417V16.667C6.2513 17.1272 5.87821 17.5003 5.41797 17.5003H3.7513C3.29106 17.5003 2.91797 17.1272 2.91797 16.667V15.0967"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.5 14.1663V12.286C2.5 11.6234 2.76308 10.9878 3.23144 10.5191L4.16667 9.58301H15.8333L16.7678 10.5174C17.2366 10.9863 17.5 11.6222 17.5 12.2852V14.1663C17.5 14.8567 16.9404 15.4163 16.25 15.4163H3.75C3.05964 15.4163 2.5 14.8567 2.5 14.1663Z"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17.4987 8.75033L15.832 9.16699"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16667 9.16699L2.5 8.75033"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.16797 9.58333V9.16167L4.86464 6.5475C5.10781 5.63497 5.93418 4.99999 6.87855 5H13.1974C14.1618 5 15.0001 5.66192 15.2238 6.6L15.8346 9.16167V9.58333"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 12.4997H6.66667"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M13.332 12.4997H14.9987"
      stroke="currentColor"
      vectorEffect="non-scaling-stroke"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));
FacilityTaxiCarPool.displayName = "FacilityTaxiCarPool";

export default FacilityTaxiCarPool;
